import React from "react";
import { Dialog, DialogContent, DialogHeader, DialogTitle } from "@/components/ui/dialog";
import { Bell, CheckCheck, MessageSquare, Heart, Music, Star } from "lucide-react";
import { format } from "date-fns";

const getNotificationIcon = (type) => {
  switch (type) {
    case "message":
      return MessageSquare;
    case "like":
      return Heart;
    case "track":
      return Music;
    case "badge":
      return Star;
    default:
      return Bell;
  }
};

export default function NotificationsModal({ 
  open, 
  onOpenChange, 
  notifications = [], 
  onNotificationClick, 
  onMarkAllRead,
  unreadCount = 0 
}) {
  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent className="bg-[#1a1a1a] border border-[#2a2a2a] w-[95vw] max-w-md max-h-[85vh] md:max-h-[80vh] overflow-hidden flex flex-col mx-auto">
        <DialogHeader className="flex-shrink-0">
          <div className="flex justify-between items-center">
            <DialogTitle className="text-[#d0d0d0] flex items-center gap-2">
              <Bell className="w-5 h-5" />
              Notifications
              {unreadCount > 0 && (
                <span className="px-2 py-0.5 rounded-full bg-[#252525] text-xs text-[#a0a0a0]">
                  {unreadCount} new
                </span>
              )}
            </DialogTitle>
            {unreadCount > 0 && (
              <button
                onClick={onMarkAllRead}
                className="text-xs text-[#808080] hover:text-[#a0a0a0] flex items-center gap-1"
              >
                <CheckCheck className="w-4 h-4" />
                Mark all read
              </button>
            )}
          </div>
        </DialogHeader>

        <div className="flex-1 overflow-y-auto space-y-2 pr-2">
          {notifications.length === 0 ? (
            <div className="flex flex-col items-center justify-center py-12 text-center">
              <Bell className="w-12 h-12 text-[#404040] mb-4" />
              <p className="text-sm text-[#707070]">No notifications yet</p>
            </div>
          ) : (
            notifications.map((notif) => {
              const Icon = getNotificationIcon(notif.type);
              let createdAtDisplay = "Just now";
              try {
                createdAtDisplay = notif?.created_at
                  ? format(new Date(notif.created_at), "MMM d, h:mm a")
                  : "Just now";
              } catch {
                createdAtDisplay = "Just now";
              }
              return (
                <div
                  key={notif.id}
                  onClick={() => onNotificationClick(notif)}
                  className={`w-full text-left rounded-xl p-3 cursor-pointer transition-all hover:bg-[#2a2a2a] ${
                    notif.is_read
                      ? "bg-[#1a1a1a]"
                      : "bg-[#252525] border border-[#3a3a3a]"
                  }`}
                >
                  <div className="flex gap-3">
                    <div className="w-8 h-8 rounded-lg flex items-center justify-center flex-shrink-0 bg-[#2a2a2a]">
                      <Icon className="w-4 h-4 text-[#808080]" />
                    </div>
                    <div className="flex-1 min-w-0">
                      <p className="text-xs font-medium text-[#d0d0d0] mb-1">
                        {notif.title}
                      </p>
                      <p className="text-xs text-[#808080] truncate">
                        {notif.message}
                      </p>
                      <p className="text-xs text-[#606060] mt-1">
                        {createdAtDisplay}
                      </p>
                    </div>
                  </div>
                </div>
              );
            })
          )}
        </div>
      </DialogContent>
    </Dialog>
  );
}
